import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { EMPTY, Observable, filter, tap } from 'rxjs';
import { Router } from '@angular/router';
import { DhabiLoaderServiceService } from 'src/app/services/loader/dhabi-loader-service.service';

@Injectable()
export class PortalInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  constructor(private route: Router, private loadingService: DhabiLoaderServiceService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++;
    this.loadingService.setLoading(true);

    return next.handle(request).pipe(
      tap({
        next: (event: any) => {
          if (event instanceof HttpResponse) {
            if(event.status == 401) {
              this.route.navigate(['login'])
              return EMPTY
            }
          }
          return event;
        },
        error: (error: any) => {
          if (error.status != undefined && error.status === 401){
            this.route.navigate(['login'])
          }
        },
      finalize : () => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false);
        }
      }
      }));
  }
}